(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-minimal"] && !Shopify.designMode) return;
  try {
    
  /* Clicking the barcode animates the page back to the top. On desktop
     (>= 990px) this theme scrolls .page-wrapper, not the window
     (base.css makes html/body overflow:hidden there) and has no CSS
     scroll-behavior, so the tween is by hand (easeOutCubic, ~0.4-0.9s
     scaled to distance). prefers-reduced-motion jumps instead. */
  (function () {
    if (window.__fmBackToTop) return;
    window.__fmBackToTop = true;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function container() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function toTop() {
      var el = container();
      var start = el.scrollTop;
      if (start <= 0) return;
      if (REDUCED.matches) { el.scrollTop = 0; return; }
      var duration = Math.min(900, Math.max(400, start * 0.6));
      var t0 = null;
      var ease = function (p) { return 1 - Math.pow(1 - p, 3); };
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / duration);
        el.scrollTop = start * (1 - ease(p));
        if (p < 1) requestAnimationFrame(step);
        else el.scrollTop = 0;
      };
      requestAnimationFrame(step);
    }

    function closeLoc(loc, focusTrigger) {
      if (!loc || !loc.classList.contains('is-open')) return;
      loc.classList.remove('is-open');
      var t = loc.querySelector('.fm__loc-trigger');
      if (t) {
        t.setAttribute('aria-expanded', 'false');
        if (focusTrigger) t.focus();
      }
    }

    /* Line the dropdown's left edge up with the country NAME in the trigger
       (not the "COUNTRY / REGION" label before it). That offset = the
       label's width + the flex gap, which depends on the rendered font, so
       measure it and stash it in --fm-loc-indent for the panel's `left`. */
    function positionLoc() {
      var loc = document.querySelector('.fm__loc');
      if (!loc) return;
      var now = loc.querySelector('.fm__loc-now');
      if (now) loc.style.setProperty('--fm-loc-indent', Math.round(now.offsetLeft) + 'px');

      var panel = loc.querySelector('.fm__loc-panel');

      /* Desktop: the panel opens under "Canada" (--fm-loc-indent, set
         above from .fm__loc-now.offsetLeft) so the list's country names
         align with the trigger's selected country. Measure the panel's
         content width into --fm-loc-width -> that stretches the name+caret
         line so the caret's right edge lands on the panel's right edge
         (where the right-aligned currency column sits). */
      if (!window.matchMedia('(max-width: 749px)').matches) {
        loc.style.removeProperty('--fm-cart-inset');
        if (panel) {
          var pw = Math.round(panel.getBoundingClientRect().width || panel.offsetWidth || 0);
          loc.style.setProperty('--fm-loc-width', (pw > 40 ? pw : 200) + 'px');
        }
        return;
      }
      loc.style.removeProperty('--fm-loc-width');

      /* Mobile only: push the country name's dropdown caret right so its
         right edge lines up with the header cart icon's left edge
         (--fm-cart-inset used as padding-inline-end on .fm__loc-line). */
      var cart = document.querySelector('.header-actions__action[aria-label="Cart"] svg')
        || document.querySelector('.header-actions__action[aria-label="Cart"]')
        || document.querySelector('[aria-label="Cart"], [aria-label="Cart" i]');
      if (!cart) { loc.style.removeProperty('--fm-cart-inset'); return; }
      var padRight = 24; /* footer mobile content padding-inline-end */
      var inset = (window.innerWidth - padRight) - cart.getBoundingClientRect().left;
      if (!isFinite(inset) || inset < 0 || inset > 140) inset = 0;
      loc.style.setProperty('--fm-cart-inset', Math.round(inset) + 'px');
    }
    positionLoc();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionLoc);
    window.addEventListener('resize', positionLoc);
    window.addEventListener('load', positionLoc);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fm-top]')) toTop();

      /* Country / currency disclosure: toggle .is-open (CSS animates the
         max-height + fade). Click the trigger to open/close; click anywhere
         outside to close. */
      var loc = document.querySelector('.fm__loc');
      if (!loc) return;
      var trigger = e.target.closest('.fm__loc-trigger');
      if (trigger && loc.contains(trigger)) {
        var isOpen = loc.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.fm__loc')) closeLoc(loc, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeLoc(document.querySelector('.fm__loc.is-open'), true);
    });

    /* Picking a market normally full-page-POSTs to /localization and lets
       Shopify redirect. Dylan wants the menu to just update in place --
       "dont refresh the page just change the selection". So intercept the
       submit, POST /localization in the background (that still sets the
       market cookie, so prices/currency switch on the next navigation),
       and move the selection + trigger label ourselves. If the fetch
       fails, fall back to the normal submit. */
    var locForm = document.getElementById('FooterLocalization');
    if (locForm && window.fetch) {
      locForm.addEventListener('submit', function (e) {
        var btn = e.submitter || document.activeElement;
        if (!btn || btn.name !== 'country_code') return;
        e.preventDefault();

        var data = new FormData(locForm);
        data.set('country_code', btn.value);

        fetch('/localization', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        })
          .then(function () {
            var loc = document.querySelector('.fm__loc');
            if (!loc) return;
            loc.querySelectorAll('.fm__loc-opt').forEach(function (opt) {
              if (opt === btn) opt.setAttribute('aria-current', 'true');
              else opt.removeAttribute('aria-current');
            });
            var nowEl = loc.querySelector('.fm__loc-now');
            var nameEl = btn.querySelector('span');
            if (nowEl && nameEl) nowEl.textContent = nameEl.textContent.trim();
            closeLoc(loc, false);
            positionLoc();
          })
          .catch(function () {
            locForm.submit();
          });
      });
    }
  })();

  /* Desktop: barcode width locked to the exact width of whatever sits at
     the right end of the bottom row, directly under it (Dylan picked
     "locked widths", 2026-10-20) so the two share both edges. That's
     ANGUS DYLAN HOME since the copyright/HOME swap; the copyright is
     still a candidate in case they swap back. Measured, not hard-coded.
     Below 750px the CSS width (--bc-w) is left alone. */
  (function () {
    var DESKTOP = window.matchMedia('(min-width: 750px)');

    function inkRect(el) {
      if (el.tagName.toLowerCase() === 'svg') return el.getBoundingClientRect();
      var range = document.createRange();
      range.selectNodeContents(el);
      return range.getBoundingClientRect();
    }

    function lockBarcodeWidth() {
      var bc = document.querySelector('.fm__bc');
      if (!bc) return;
      if (!DESKTOP.matches) {
        bc.style.removeProperty('--bc-w');
        return;
      }
      // Desktop barcode width is a fixed 190px in CSS now (it used to be locked to
      // whatever sat under it); clear any inline width left from the old lock.
      bc.style.removeProperty('--bc-w');
    }

    // Desktop: ANGUS DYLAN HOME sits on the same horizontal line as the
    // "ENTER EMAIL FOR UPDATES" field (Dylan: "center aligned horizontally with the
    // enter email for updates") -- its vertical centre = the field's vertical
    // centre. Measured, so it holds if the type or spacing changes; the CSS `top`
    // is only the fallback before this runs.
    function alignHomeToEmail() {
      var home = document.querySelector('.fm__home');
      var top = document.querySelector('.fm__top');
      var input = document.querySelector('.fm__nl-input');
      if (!home || !top || !input) return;
      if (!DESKTOP.matches) {
        home.style.removeProperty('top');
        return;
      }
      var t = top.getBoundingClientRect();
      var i = input.getBoundingClientRect();
      if (!i.height) return;
      home.style.top = Math.round((i.top + i.height / 2 - t.top) * 10) / 10 + 'px';
    }
    alignHomeToEmail();
    window.addEventListener('load', alignHomeToEmail);
    window.addEventListener('resize', alignHomeToEmail);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignHomeToEmail);

    lockBarcodeWidth();
    window.addEventListener('load', lockBarcodeWidth);
    window.addEventListener('resize', lockBarcodeWidth);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockBarcodeWidth);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Social Content is a `group` block (heading text-block + social-links),
     not a menu block, so it can't get the native <details> accordion the
     other footer columns use. Wrap it in one here so it's a +/- drop-down
     on mobile too. Desktop CSS (.footer-collapsible rules in this section)
     force it open and hide the toggle, so this is safe to leave in the DOM
     at every width. */
  (function () {
    if (window.__footerSocialAccordion) return;
    window.__footerSocialAccordion = true;

    function build() {
      try {
        var fc = document.querySelector('.footer-content');
        if (!fc) return;
        var list =
          fc.querySelector('.social-icons__wrapper') ||
          fc.querySelector('.social-links') ||
          fc.querySelector('.social-icons');
        if (!list) return;

        // The grid child (column) that holds the Social Content group.
        var col = list.closest('.footer-content > *');
        if (!col || col.dataset.socialAccordion) return;

        var heading =
          col.querySelector("[class*='text_social_heading']") ||
          col.querySelector('.text-block') ||
          col.querySelector('.menu__heading');
        if (!heading) return;

        var host = heading.parentElement;
        if (!host) return;

        col.dataset.socialAccordion = 'true';

        var details = document.createElement('details');
        details.className = 'menu footer-collapsible footer-collapsible--social';

        var summary = document.createElement('summary');
        summary.className = 'menu__heading h4';
        summary.textContent = (heading.textContent || 'Social Content').trim();

        details.appendChild(summary);

        // Move the heading's following siblings (the social list, etc.)
        // into the <details>, then REMOVE the original heading outright --
        // just hiding it left a second "SOCIAL CONTENT" label because a
        // `.text-block { display: flex }` rule out-specced `[hidden]`.
        var sib = heading.nextElementSibling;
        while (sib) {
          var next = sib.nextElementSibling;
          details.appendChild(sib);
          sib = next;
        }
        host.appendChild(details);
        heading.remove();
      } catch (e) {
        /* leave the footer untouched on any failure */
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else {
      build();
    }
  })();

  /* Desktop: the Fine Print / Language / Social Content <details> must
     never collapse -- newer engines hide a closed <details>'s content via
     ::details-content (content-visibility:hidden), which CSS on the
     children can't override. Forcing the `open` attribute is the only
     reliable way, so do it here (>= 750px). Mobile leaves them toggleable;
     the animation is pure CSS (see the stylesheet) matching Horizon's own
     accordion. */
  (function () {
    if (window.__footerCollapsibleDesktop) return;
    window.__footerCollapsibleDesktop = true;

    var DESKTOP = window.matchMedia('(min-width: 750px)');

    function apply() {
      var isDesktop = DESKTOP.matches;
      document.querySelectorAll('.footer-content details.footer-collapsible').forEach(function (d) {
        if (isDesktop) d.open = true;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }
    window.setTimeout(apply, 0); /* catch the JS-built Social Content <details> */
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-hold-demo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hhdInit) return;
    window.__hhdInit = true;

    function initTile(tile) {
      var action = tile.dataset.action || 'freeze';
      var frame = tile.querySelector('.hhd__frame');
      var typeText = tile.dataset.typeText || '';
      var cycleTexts = (tile.dataset.cycleTexts || '').split('|').filter(Boolean);
      var originalText = frame ? frame.textContent : '';
      var isTyper = frame ? frame.classList.contains('hhd__typing') : false;

      var cycleTimer = null;
      var typeTimer = null;
      var on = false;

      function reset() {
        on = false;
        tile.classList.remove('is-hover');
        if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
        if (typeTimer) { clearTimeout(typeTimer); typeTimer = null; }
        if (frame) {
          frame.classList.remove('is-swapping');
          if (isTyper) frame.classList.add('hhd__typing');
          frame.textContent = originalText;
        }
      }

      function activate() {
        if (on) return;
        on = true;
        tile.classList.add('is-hover');
        if (action === 'cycle') {
          startCycle();
        } else if (action === 'video') {
          /* Let the enlarge land first, then start the video sequence. */
          typeTimer = setTimeout(function () { if (on) startTyping(); }, 375);
        }
        /* freeze: nothing beyond staying enlarged */
      }

      /* Semi-rapid straight image-to-image swap, no fade. */
      function startCycle() {
        if (!frame || cycleTexts.length < 2) return;
        var i = 0;
        cycleTimer = setInterval(function () {
          if (!on) return;
          i = (i + 1) % cycleTexts.length;
          frame.textContent = cycleTexts[i];
        }, 360);
      }

      /* Type the message once, start to finish, then reset to the image. */
      function startTyping() {
        if (!frame) return;
        var n = 0;
        frame.textContent = '';
        (function step() {
          if (!on) return;
          if (n < typeText.length) {
            n += 1;
            frame.textContent = typeText.slice(0, n);
            typeTimer = setTimeout(step, 28);
          } else {
            typeTimer = setTimeout(function () {
              if (!on) return;
              frame.classList.remove('hhd__typing');
              frame.textContent = originalText;
            }, 550);
          }
        })();
      }

      tile.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') activate();
      });
      tile.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') reset();
      });
      tile.addEventListener('click', function () {
        if (on) reset(); else activate();
      });
      tile.addEventListener('focus', function () { activate(); });
      tile.addEventListener('blur', function () { reset(); });
      tile.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (on) reset(); else activate();
      });
    }

    function applySubnavGap() {
      var subnav = document.querySelector('.header__row--bottom');
      if (!subnav) return;
      var h = Math.round(subnav.getBoundingClientRect().height);
      if (h <= 0) return;
      document.querySelectorAll('.hhd__row').forEach(function (row) {
        row.style.setProperty('--hhd-gap', h + 'px');
      });
    }

    function boot() {
      var tiles = document.querySelectorAll('.hhd .hhd__tile');
      if (!tiles.length) return;
      tiles.forEach(initTile);
      applySubnavGap();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    window.addEventListener('resize', applySubnavGap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
